import { useCage } from '@/contexts/cage';
import {
    isLandbasedTank,
    isSmoltProductionTank,
    isTroutFishType,
} from '@/utils/locationTypeHelpers';

/**
 * Cage-level fish/tank type flags, derived from the cage context — no query of their own.
 *
 * All three read data that already ships with `useGetCageContext`, so they resolve on the same
 * tick as `useCage().loading` and return `false` while it is still loading.
 *
 * They must be called inside a `CageProvider`. Outside it (e.g. `AppSidebar`, which sits above
 * the provider on purpose) derive from `useGetCageContext(cageId)` directly, as `useSidebarFilter`
 * does.
 *
 * Location-level equivalents are a different concept — see `isSmoltLocation` /
 * `isLandbasedLocation` in `locationTypeHelpers`.
 */
export function useIsTrout(): boolean {
    const { stock } = useCage();

    // `stock.fishType` is the PEN's species, with its location as the fallback (WB-2207), so
    // this gates trout features on the pen even at a site holding several species.
    return isTroutFishType(stock?.fishType);
}

export function useIsSmolt(): boolean {
    const { cage } = useCage();

    return isSmoltProductionTank(cage?.cageType);
}

export function useIsLandbased(): boolean {
    const { cage } = useCage();

    return isLandbasedTank(cage?.cageType);
}
